import axios from 'axios';

export const state = {
    allInfluencers: [],
};

export const mutations = {
    SET_ALL_INFLUENCERS(state, influencers) {
        state.allInfluencers = influencers;
    },
    CLEAR (state) {
        state.allInfluencers = [];
    },
};

export const getters = {
    hasAllInfluencers (state) {
        return state.allInfluencers.length > 0;
    },
};

export const actions = {
    async getAllInfluencers({ commit }) {
        try{
            const { data } = await axios.get('/client/influencer/search/setup');
            commit('SET_ALL_INFLUENCERS', data);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e)
        }
    },
};
